<section class="service-section">
  <div class="left-content">
    <h1 class="header-title">
      <span class="text-accent">
        {{ data?.title?.split(" ", 2).join(" ") }}
      </span>
      {{ data?.title?.split(" ").slice(2).join(" ") }}
    </h1>
    <h5 class="description" [innerHTML]="data?.content"></h5>
    <app-whatsapp-button [buttonText]="data?.buttontext" />
  </div>

  <div class="right-content">
    <img
      class="monitor-image"
      [src]="data?.imgsrc"
      [alt]="data?.name"
    />
  </div>
</section>
